import React, { Component } from "react";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";

import moment from "moment";
moment.locale("ar");
const arabicMonths = [
  "يناير",
  "فبراير",
  "مارس",
  "أبريل",
  "مايو",
  "يونيو",
  "يوليو",
  "أغسطس",
  "سبتمبر",
  "أكتوبر",
  "نوفمبر",
  "ديسمبر",
];
moment.updateLocale("fr", { weekdaysMin: "U_M_T_W_R_F_S".split("_") });
export default class Calendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      isRange: false,
      dateFrom: new Date(),
      dateTo: new Date(),
      clicked: 0, // if range clicked only 2
    };
    moment.locale(this.props.locale ? this.props.locale : "ar");
  }
  WeekDayName = () => {
    let weekdayshort = moment.weekdaysShort();
    console.log(weekdayshort);
    return weekdayshort.map((day, index) => {
      return (
        <th
          key={index}
          style={
            this.props.weekDayStyle ? this.props.weekDayStyle : weekDayStyle
          }
        >
          {day.charAt(0)}
        </th>
      );
    });
  };
  firstDayOfMonth = () => {
    let date = this.state.date;
    let firstDay = moment(date).startOf("month").format("d");
    return firstDay;
  };
  endDayOfPreviuosMonth = () => {
    let date = this.state.date;
    date = moment(date).add(-1, "months").calendar();

    return moment(date).daysInMonth();
  };
  calendarBody = () => {
    let date = this.state.date;

    // days of the previuos month
    let blanks = [];
    for (let i = 0; i < this.firstDayOfMonth(); i++) {
      blanks.push(
        <td key={i * 45} style={blanckDaystyle}>
          {this.endDayOfPreviuosMonth() - (this.firstDayOfMonth() - i) + 1}
        </td>
      );
    }
    // days of the current month
    let daysInMonth = [];
    for (let d = 1; d <= moment(date).daysInMonth(); d++) {
      daysInMonth.push(
        <td
          key={d}
          onClick={() => {
            this.setState({ finalDate: moment(date).set("date", d) });
            this.onChange(moment(date).set("date", d));
          }}
          style={
            this.props.customCell
              ? {}
              : { ...dayStyle, ...this.activeDaystyle(d, date) }
          }
        >
          {this.props.customCell ? this.props.customCell(d) : d}
        </td>
      );
    }
    var blanksNext = [];

    var totalSlots = [...blanks, ...daysInMonth];
    let countNextBlanks = 35 - totalSlots.length;
    for (let i = 1; i <= countNextBlanks; i++) {
      totalSlots.push(
        <td key={i * 78} style={blanckDaystyle}>
          {i}
        </td>
      );
    }
    let rows = [];
    let cells = [];
    totalSlots.forEach((row, i) => {
      if (i % 7 !== 0) {
        cells.push(row); // if index not equal 7 that means not go to next week
      } else {
        rows.push(cells); // when reach next week we contain all td in last week to rows
        cells = []; // empty container
        cells.push(row); // in current loop we still push current row to new container
      }
      if (i === totalSlots.length - 1) {
        // when end loop we add remain date
        rows.push(cells);
      }
    });
    return rows.map((d, i) => {
      return <tr key={i}>{d}</tr>;
    });
  };
  activeDaystyle = (d, day) => {
    return moment(this.state.finalDate).format("D") == d &&
      moment(day).year() == moment(this.state.finalDate).year() &&
      moment(day).month() == moment(this.state.finalDate).month()
      ? { color: "#fff", background: "#5360ac" }
      : {};
  };
  // working with month
  month = () => {
    console.log();
    if (this.props.locale == "ar") {
      return (
        <>
          <span>{arabicMonths[moment(this.state.date).month()]}</span>
          <span> {" " + moment(this.state.date).year() + " "}</span>
        </>
      );
    }
    {
    }
    return (
      <>
        <span>{moment(this.state.date).format("MMMM")}</span>
        <span> {" " + moment(this.state.date).year() + " "}</span>
      </>
    );
  };
  nextMonth = (isNext) => {
    let date = moment(this.state.date).format("MM/DD/YYYY");
    if (isNext) {
      this.setState({
        date: moment(date).add(1, "months"),
      });
      this.props.selectMonth &&
        this.props.selectMonth(moment(date).add(1, "months"));
    } else {
      this.setState({
        date: moment(date).subtract(1, "months"),
      });
      this.props.selectMonth &&
        this.props.selectMonth(moment(date).subtract(1, "months"));
    }
    console.log(this.state.date);
  };
  // manupilate the change of the range or just picker
  onChange = (value) => {
    value = moment(value).format("MM/DD/YYYY");
    if (this.props.isRange) {
      if (this.state.clicked == 0) {
        this.setState({ clicked: 1 });
        if (this.props.onChange) {
          this.props.onChange(value, 1);
        }
      } else {
        this.setState({ clicked: 0 });
        if (this.props.onChange) {
          this.props.onChange(value, 2);
        }
      }
    } else if (this.props.onChange) {
      this.props.onChange(value);
    }
  };
  render() {
    return (
      <div style={calendarStyle}>
        <div style={monthStyle} dir={this.props.locale == "ar" ? "rtl" : "ltr"}>
          <button
            style={previousNextStyle}
            onClick={() => this.nextMonth(false)}
          >
            {" "}
            <IoIosArrowBack />
          </button>{" "}
          <span style={monthStyleName}>{this.month()}</span>
          <button
            style={previousNextStyle}
            onClick={() => this.nextMonth(true)}
          >
            <IoIosArrowForward />
          </button>{" "}
        </div>
        <table style={tablestyle}>
          <thead>
            <tr>{this.WeekDayName()}</tr>
          </thead>
          <tbody>{this.calendarBody()}</tbody>
        </table>
      </div>
    );
  }
}

//----------- styles
const pcolor = "#5360ac";
//--------------------

const calendarStyle = {
  background: "white",
  width: "100%",
  height: "calc(110vh - 150px)",
  padding: "0px",
  // position: "absolute",
  top: "20px",
  left: "50%",
  // transform: "translateX(-50%)",
  boxShadow: "2px 2px 21px -10px rgba(0,0,0,0.75)",
};
const tablestyle = {
  borderCollapse: "collapse",
};
const weekDayStyle = {
  width: "42px",
  height: "43px",
  // lineHeight: "43px",

  textAlign: "center",
  color: pcolor,
};
const dayStyle = {
  width: "42px",
  height: "100px",
  // lineHeight: "43px",
  cursor: "pointer",
  textAlign: "center",
  display: "cell",
  color: "#222",
  fontWeight: "bold",
  border: "1px solid #eee",
  //  color: "rgb(210,147,22)",
};
const blanckDaystyle = {
  width: "42px",
  height: "43px",
  // lineHeight: "43px",

  textAlign: "center",
  display: "cell",
  color: "#ddd",
};
const monthStyle = {
  padding: "10px ",
  // textAlign: "center",
};
const monthStyleName = {
  display: "inline-block",
  // width: "calc(100% - 65px)",
  textAlign: "center",
  color: pcolor,
  fontSize: "1,1em",
  fontWeight: "bold",
  padding: " 0 10px",
};
const previousNextStyle = {
  color: "#fff",
  fontSize: "20px",
  background: pcolor,
  display: "inline-block",
  lineHeight: "40px",
  width: "40px",
  textAlign: "center",
  border: "0 none",
  outline: "0 none",
  cursor: "pointer",
  borderRadius: "8px",
};
